import React, {useEffect, useState} from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {useDispatch, useSelector} from "react-redux";
import {useForm} from "react-hook-form";
import {addBRIdentityProvided} from "../../../actions";
import {TextField} from "@material-ui/core";
import IntlMessages from "../../../util/IntlMessages";
import BBExternalLink from "../accents/BBExternalLink";
import Button from "@material-ui/core/Button";


const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(2),
        minWidth: 120,
    },
    root: {
        '& > *': {
            margin: theme.spacing(1),
            width: '50ch',
        },
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}));

const NewBRIdentityProvidedForm = ({entityId = null,})=>{

    const {didJustCreateNewIdentityProvided} = useSelector(({breachrisk})=>breachrisk.appMisc);
    const classes = useStyles();

    const {customerInView} = useSelector(({customer}) => customer);
    const dispatch = useDispatch();

    const [email, setEmail] = useState(null);
    const [first, setFirst] = useState(null);
    const [last, setLast] = useState(null);

    const clearForm = () =>{
        setEmail("");
        setFirst("");
        setLast("");
        document.getElementById("NewBRIdentityProvidingForm").reset();
    }

    useEffect(()=>{
        if(didJustCreateNewIdentityProvided){
            clearForm();
        }
    },[dispatch, didJustCreateNewIdentityProvided]);

    const { register, handleSubmit, errors } = useForm();

    const onSubmit = data => {
        dispatch(addBRIdentityProvided({
        "customerId": customerInView,
        "entityId": entityId,
        "first": first ? first: null,
        "last": last ? last: null,
        "email": email,
    }));
    }

    return(
        <div className="animated fadeIn animation-duration-7">
            <form id={"NewBRIdentityProvidingForm"} className={classes.root}>
                {/*<h3>Email</h3>*/}
                <TextField
                    label={<IntlMessages id="appModule.newBRIdentityProviding.email"/>}
                    fullWidth
                    id="email"
                    name="email"
                    required
                    error={!!errors.email}
                    onChange={(event) => setEmail(event.target.value)}
                    defaultValue={email}
                    margin="normal"
                    className="mt-1 my-sm-3 d-block"
                    inputRef={register({
                        required: "This field is required." ,
                        // pattern: /^([a-z0-9\s]+,)*([a-z0-9\s]+){1}$/i
                    })}
                    helperText={(!errors.name &&
                        <>Enter an email address for your company to include it in social testing.</>) || errors.email.message}
                />

                {/*<h3>First Name</h3>*/}
                <TextField
                    label={<IntlMessages id="appModule.newBRIdentityProviding.first_name"/>}
                    fullWidth
                    id="first"
                    name="first"
                    error={!!errors.first}
                    onChange={(event) => setFirst(event.target.value)}
                    defaultValue={first}
                    margin="normal"
                    className="mt-1 my-sm-3 d-block"
                    helperText={(!errors.name &&
                        <></>) || errors.first.message}
                />

                {/*<h3>Last Name</h3>*/}
                <TextField
                    label={<IntlMessages id="appModule.newBRIdentityProviding.last_name"/>}
                    fullWidth
                    id="last"
                    name="last"
                    error={!!errors.last}
                    onChange={(event) => setLast(event.target.value)}
                    defaultValue={last}
                    margin="normal"
                    className="mt-1 my-sm-3 d-block"
                    helperText={(!errors.name &&
                        <></>) || errors.last.message}
                />

                <br/>
                <br/>
                <div className="mb-3 d-flex align-items-center justify-content-between">

                    <Button onClick={handleSubmit(onSubmit)}
                            disabled={!!errors.email}
                            variant="contained" color="primary">
                        <IntlMessages id="form.submit"/>
                    </Button>
                </div>

            </form>

        </div>
    )
}

export default NewBRIdentityProvidedForm;